import staticData from '../config/staticData'

export default function getLabels(label, customFallbackMessage) {
  if (label[0] === '[' && label[label.length - 1] === ']') {
    const newLabel = label.replace(/\[/g, '').replace(/]/g, '')
    return staticData.labels[newLabel] || (customFallbackMessage || newLabel)
  }
  return staticData.labels[label] || (customFallbackMessage || label)
}
